module.exports = __webpack_public_path__ + "img/ru7.ca8ddc3c.jpg";